import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { JtsSidebarMenuService } from './jts-sidebar-menu.service';
import { UserPreferenceModel } from './user-preference.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'lib-jts-sidebar-menu',
  templateUrl: './jts-sidebar-menu.component.html',
  styleUrls: ['./jts-sidebar-menu.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class JtsSidebarMenuComponent implements AfterViewInit, OnInit {
  @Input() serverUrl = '';
  @Input() isCore = false;
  @Input() djjUserAcID = null;
  @Input() juvenileID = null;
  @Input() sitLocationCode = null;
  @Input() moduleName = '';
  @Input() rolePermission: any = {};
  @Input() sitModOp: any = '';
  @Output() backgroundColor = new EventEmitter();
  @Output() currentModuleClicked = new EventEmitter();
  @ViewChild('anchor') public anchor: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup: ElementRef;

  isSideBarCollapseActive = false;
  userPreference: UserPreferenceModel = new UserPreferenceModel();
  djjUserLName = '';
  djjUserFName = '';
  djjUserID = '';
  openedReportIssue = false;
  showSetting = false;
  openedModifyPageLayout = false;
  isEditSiteLayout = true;
  isLoading = false;
  userID: any = '';
  buttonActive: any = [];
  customBackground = '#ffffff';
  tabId: any;
  userAcID: any;
  openedAbout = false;
  constructor(
    private jtsSidebarMenuService: JtsSidebarMenuService,
    private sanitizer: DomSanitizer
  ) {
    for (let i = 0; i < 50; i++) {
      this.buttonActive.push(false);
    }
  }
  @HostListener('keydown', ['$event'])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }
  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  toggleSideBarClicked() {
    $('#sidebar, #content').toggleClass('active');
  }

  ngOnInit() {
    this.jtsSidebarMenuService.serverUrl = this.serverUrl;
    this.jtsSidebarMenuService.getPropertyConfig();
  }

  ngAfterViewInit(): void {
    const supportPageOffset = window.pageXOffset !== undefined;
    const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
    const demoItem2 = document.getElementById('sidebar');
    window.addEventListener('scroll', (e) => {
      const x = supportPageOffset
        ? window.pageXOffset
        : isCSS1Compat
        ? document.documentElement.scrollLeft
        : document.body.scrollLeft;

      demoItem2.style.left = -x + 'px';
    });

    const ua = navigator.userAgent;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    ) {
      this.isEditSiteLayout = false;
    }

    if (this.isCore === true) {
      const helper = new JwtHelperService();
      this.userID = sessionStorage.getItem('userID');
      this.jtsSidebarMenuService
        .getJtsUserInfoGlobalAsa(this.userID, this.juvenileID)
        .subscribe((resp: any) => {
          const djjUserAcID = resp.djjUserAcID;
          this.jtsSidebarMenuService
            .getUserPreference(djjUserAcID)
            .subscribe((response: any) => {
              this.userPreference.djjUserAcId = response.djjUserAcId;
              this.userPreference.contentPosition = response.contentPosition;
              this.userPreference.bannerPosition = response.bannerPosition;
              this.userPreference.bannerFullScreen = response.bannerFullScreen;
              this.userPreference.background = response.background;
              this.djjUserFName = response.djjUserFName;
              this.djjUserLName = response.djjUserLName;
              this.djjUserLName = response.djjUserLName;
              this.djjUserID = response.djjUserID;
              this.djjUserAcID = djjUserAcID;
              this.sitLocationCode = resp.sitLocationCode;
              if (this.userPreference.background === 'logo') {
                this.customBackground = '#ffffff';
                this.backgroundColor.emit('logo');
              } else {
                this.customBackground = this.userPreference.background;
                this.backgroundColor.emit(this.userPreference.background);
              }
            });
        });
    } else {
      this.userID = sessionStorage.getItem('userID');
      this.jtsSidebarMenuService
        .getUserPreference(this.djjUserAcID)
        .subscribe((response: any) => {
          this.userPreference.djjUserAcId = response.djjUserAcId;
          this.userPreference.contentPosition = response.contentPosition;
          this.userPreference.bannerPosition = response.bannerPosition;
          this.userPreference.bannerFullScreen = response.bannerFullScreen;
          this.userPreference.background = response.background;
          this.djjUserFName = response.djjUserFName;
          this.djjUserLName = response.djjUserLName;
          this.djjUserLName = response.djjUserLName;
          this.djjUserID = response.djjUserID;
          if (this.isEditSiteLayout === true) {
            if (this.userPreference.background === 'logo') {
              this.customBackground = '#ffffff';
              this.backgroundColor.emit('logo');
            } else {
              this.customBackground = this.userPreference.background;
              this.backgroundColor.emit(this.userPreference.background);
            }
          }
        });
    }
  }

  openNewSession() {
    window.open(this.serverUrl + 'JTSnxCore/#/', '_blank');
  }

  toSearch() {
    if (this.isCore !== true) {
      window.open(this.serverUrl + 'JTSnxCore/#/?isToSearch=true', '_self');
    }
  }

  public toggle(show?: boolean): void {
    this.showSetting = show !== undefined ? show : !this.showSetting;
  }

  private contains(target: any): boolean {
    return (
      this.anchor.nativeElement.contains(target) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }

  contentPositionClicked(num) {
    if (this.userPreference.contentPosition !== num) {
      this.userPreference.contentPosition = num;
      this.isLoading = true;
      this.jtsSidebarMenuService
        .updateUserPreference(this.userPreference)
        .subscribe(() => {
          this.isLoading = false;
        });
    }
  }

  bannerFullScreenClicked(bool) {
    if (this.userPreference.bannerFullScreen !== bool) {
      this.userPreference.bannerFullScreen = bool;
      this.isLoading = true;
      this.jtsSidebarMenuService
        .updateUserPreference(this.userPreference)
        .subscribe(() => {
          this.isLoading = false;
        });
    }
  }

  bannerPositionClicked(num) {
    if (this.userPreference.bannerPosition !== num) {
      this.userPreference.bannerPosition = num;
      this.isLoading = true;
      this.jtsSidebarMenuService
        .updateUserPreference(this.userPreference)
        .subscribe(() => {
          this.isLoading = false;
        });
    }
  }

  setCustomBackgroundClicked() {
    this.userPreference.background = this.customBackground;
    this.isLoading = true;
    this.jtsSidebarMenuService
      .updateUserPreference(this.userPreference)
      .subscribe(() => {
        this.isLoading = false;
        this.backgroundColor.emit(this.userPreference.background);
      });
  }

  setToLogoClicked() {
    this.userPreference.background = 'logo';
    this.isLoading = true;
    this.jtsSidebarMenuService
      .updateUserPreference(this.userPreference)
      .subscribe(() => {
        this.isLoading = false;
        this.backgroundColor.emit('logo');
      });
  }

  openReportIssue() {
    this.openedReportIssue = true;
  }

  openFAQS() {
    window.open(
      this.serverUrl + 'JTSnxFAQS/?userid=' + this.userID,
      '_blank',
      'width=800,height=600'
    );
  }

  AssessmentClicked() {
    this.tabId = sessionStorage.getItem('TabId');

    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (
      this.juvenileID === -1 ||
      this.juvenileID === null ||
      this.juvenileID === undefined
    ) {
      this.searchClicked();
    } else {
      if (this.moduleName === 'JTSnxAssessment') {
        this.currentModuleClicked.emit('JTSnxAssessment');
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Assessment',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxAssessment/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  admissionClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (
      this.juvenileID === -1 ||
      this.juvenileID === null ||
      this.juvenileID === undefined
    ) {
      this.searchClicked();
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'Contact Log',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxCore/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID +
              '&isToAdmission=true',
            '_self'
          );
        });
    }
  }

  apprehensionClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxApprehension') {
      this.currentModuleClicked.emit('JTSnxApprehension');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Apprehension',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxApprehension/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  caseNotesClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxCaseContact') {
      this.currentModuleClicked.emit('JTSnxCaseContact');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'CaseNotes',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxCaseContact/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  contactLogClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxVisitation') {
      this.currentModuleClicked.emit('JTSnxVisitation');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Contact Log',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxVisitation/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  correspondenceClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxCorrespondence') {
      this.currentModuleClicked.emit('JTSnxCorrespondence');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        alert(
          'You must first select a Juvenile in order to utilize the selected module'
        );
        this.searchClicked();
      } else {
        const item: any = this.jtsSidebarMenuService.propertyCofig.find(
          (a) => a.property === 'Correspondence'
        );
        if (item.currentPlatform === 'Angular') {
          window.open(
            this.serverUrl +
              'JTSnxCorrespondence/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        } else {
          this.jtsSidebarMenuService
            .setAuth(this.tabId, this.userAcID)
            .subscribe(() => {
              const userTractingModel = {
                UserId: this.userAcID,
                AppId: 'JTSnx',
                AppPage: 'MainMenu',
                Module: 'JTSnxCore',
                PageFunction: 'Correspondence',
              };
              this.jtsSidebarMenuService
                .insertUserTractingForMainMemu(userTractingModel)
                .subscribe(() => {
                  window.open(
                    this.serverUrl +
                      'JTSnxCore/#/?tabid=' +
                      this.tabId +
                      '&djjuseracid=' +
                      this.userAcID +
                      '&isToCorrespondence=true',
                    '_self'
                  );
                });
            });
        }
      }
    }
  }

  demographicsClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');

    if (
      this.juvenileID === -1 ||
      this.juvenileID === null ||
      this.juvenileID === undefined
    ) {
      this.searchClicked();
    } else {
      this.jtsSidebarMenuService
        .setAuth(this.tabId, this.userAcID)
        .subscribe(() => {
          this.jtsSidebarMenuService
            .GetAppState(this.tabId, this.userAcID)
            .subscribe((response: any) => {
              if (
                response.djjAdmitDate !== '' &&
                response.djjAdmitDate !== null &&
                response.djjAdmitDate !== '1900-01-01T00:00:00'
              ) {
                if (
                  !(
                    this.rolePermission.programmers ||
                    this.rolePermission.titleVReadOnly ||
                    this.rolePermission.titleVFullRights ||
                    this.rolePermission.officeOfClassification ||
                    this.rolePermission.jtS2000ReadOnly ||
                    this.rolePermission.jtsJudges ||
                    this.rolePermission.interstateCompact ||
                    this.rolePermission.jtsdcsReadOnly
                  )
                ) {
                  this.jtsSidebarMenuService
                    .getDemoInfoToCheck(this.juvenileID)
                    .subscribe((response3: any) => {
                      if (
                        !(
                          response3.countSelf !== 0 &&
                          response3.countMother !== 0 &&
                          response3.countFather !== 0 &&
                          response3.countLivesWith !== 0 &&
                          response3.countLegalCustody !== 0
                        )
                      ) {
                        if (this.moduleName === 'JTSnxDemographics') {
                          this.currentModuleClicked.emit('familyneed');
                        } else {
                          window.open(
                            this.serverUrl +
                              'JTSnxDemographics/#/?tabid=' +
                              this.tabId +
                              '&djjuseracid=' +
                              this.userAcID +
                              '&familyneed=true',
                            '_self'
                          );
                        }
                      } else {
                        if (this.moduleName === 'JTSnxDemographics') {
                          this.currentModuleClicked.emit('JTSnxDemographics');
                        } else {
                          const userTractingModel = {
                            UserId: this.userAcID,
                            AppId: 'JTSnx',
                            AppPage: 'MainMenu',
                            Module: 'JTSnxCore',
                            PageFunction: 'Demographics',
                          };
                          this.jtsSidebarMenuService
                            .insertUserTractingForMainMemu(userTractingModel)
                            .subscribe(() => {
                              window.open(
                                this.serverUrl +
                                  'JTSnxDemographics/#/?tabid=' +
                                  this.tabId +
                                  '&djjuseracid=' +
                                  this.userAcID,
                                '_self'
                              );
                            });
                        }
                      }
                    });
                } else {
                  if (this.moduleName === 'JTSnxDemographics') {
                    this.currentModuleClicked.emit('JTSnxDemographics');
                  } else {
                    const userTractingModel = {
                      UserId: this.userAcID,
                      AppId: 'JTSnx',
                      AppPage: 'MainMenu',
                      Module: 'JTSnxCore',
                      PageFunction: 'Demographics',
                    };
                    this.jtsSidebarMenuService
                      .insertUserTractingForMainMemu(userTractingModel)
                      .subscribe(() => {
                        window.open(
                          this.serverUrl +
                            'JTSnxDemographics/#/?tabid=' +
                            this.tabId +
                            '&djjuseracid=' +
                            this.userAcID,
                          '_self'
                        );
                      });
                  }
                }
              } else {
                window.open(
                  this.serverUrl +
                    'JTSnxCore/#/?tabid=' +
                    this.tabId +
                    '&djjuseracid=' +
                    this.userAcID +
                    '&isToAdmission=true',
                  '_self'
                );
              }
            });
        });
    }
  }

  disciplinaryClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxDisciplinary') {
      this.currentModuleClicked.emit('JTSnxDisciplinary');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        alert('Juvenile/location information is missing!');
        this.searchClicked();
      } else {
        const item: any = this.jtsSidebarMenuService.propertyCofig.find(
          (a) => a.property === 'Disciplinary'
        );
        if (item.currentPlatform === 'Angular') {
          window.open(
            this.serverUrl +
              'JTSnxDisciplinary/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        } else {
          this.jtsSidebarMenuService
            .setAuth(this.tabId, this.userAcID)
            .subscribe(() => {
              this.jtsSidebarMenuService
                .setAuth(this.tabId, this.userAcID)
                .subscribe(() => {
                  const userTractingModel = {
                    UserId: this.userAcID,
                    AppId: 'JTSnx',
                    AppPage: 'MainMenu',
                    Module: 'JTSnxCore',
                    PageFunction: 'Disciplinary',
                  };
                  this.jtsSidebarMenuService
                    .insertUserTractingForMainMemu(userTractingModel)
                    .subscribe(() => {
                      window.open(
                        this.serverUrl +
                          'JTSnxCore/#/?tabid=' +
                          this.tabId +
                          '&djjuseracid=' +
                          this.userAcID +
                          '&isToDisciplinary=true',
                        '_self'
                      );
                    });
                });
            });
        }
      }
    }
  }

  educationClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxEducation') {
      this.currentModuleClicked.emit('JTSnxEducation');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        alert('You have to select a juvenile to access Education');
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Education',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxEducation/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }
  facilityProgClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxFacilityProg') {
      this.currentModuleClicked.emit('JTSnxFacilityProg');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'FacilityProg',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxFacilityProg/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  foodServiceClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxFoodService') {
      this.currentModuleClicked.emit('JTSnxFoodService');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'FoodService',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxFoodService/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  housingClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxHousing') {
      this.currentModuleClicked.emit('JTSnxHousing');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Housing',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxHousing/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  interstateClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxInterstate') {
      this.currentModuleClicked.emit('JTSnxInterstate');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'IntCompact',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxInterstate/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  legalClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxLegal') {
      this.currentModuleClicked.emit('JTSnxLegal');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        alert(
          'You must first select a Juvenile in order to utilize the selected module'
        );
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Legal',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxLegal/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  medicalClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxMedical') {
      this.currentModuleClicked.emit('JTSnxMedical');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'Medical',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxMedical/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  obhsClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxOBHS') {
      this.currentModuleClicked.emit('JTSnxOBHS');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'OBHS',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxOBHS/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  offSiteClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxOffsite') {
      this.currentModuleClicked.emit('JTSnxOffsite');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Offsite',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxOffsite/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  placementClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxPlacement') {
      this.currentModuleClicked.emit('JTSnxPlacement');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        alert(
          'You must first select a Juvenile in order to utilize the selected module'
        );
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Placement',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxPlacement/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  reportsClicked() {
    if (this.moduleName === 'JTSnxReports') {
      this.currentModuleClicked.emit('JTSnxReports');
    } else {
      this.tabId = sessionStorage.getItem('TabId');
      this.userAcID = sessionStorage.getItem('DJJUserAcId');
      window.open(
        this.serverUrl +
          'JTSnxReports/#/?tabid=' +
          this.tabId +
          '&djjuseracid=' +
          this.userAcID,
        '_self'
      );
    }
  }

  rbwoPoCClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxRBWOPoC') {
      this.currentModuleClicked.emit('JTSnxRBWOPoC');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'RBWOPoC',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxRBWOPoC/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  rpsClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxRPS') {
      this.currentModuleClicked.emit('JTSnxRPS');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'RPS',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxRPS/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  sanctionsClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxGraduatedSanctions') {
      this.currentModuleClicked.emit('JTSnxGraduatedSanctions');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'GraduatedSanctions',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxGraduatedSanctions/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  screeningClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxScreening') {
      this.currentModuleClicked.emit('JTSnxScreening');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Screening',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxScreening/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  sirClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxSIR') {
      this.currentModuleClicked.emit('JTSnxSIR');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'SIR',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxSIR/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  transferClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxTransfer') {
      this.currentModuleClicked.emit('JTSnxTransfer');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Transfer',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxTransfer/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  titleIVEClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxTitleIVE') {
      this.currentModuleClicked.emit('JTSnxTitleIVE');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'TitleIVE',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxTitleIVE/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  victimInfoClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxVictimInfo') {
      this.currentModuleClicked.emit('JTSnxVictimInfo');
    } else {
      const userTractingModel = {
        UserId: this.userAcID,
        AppId: 'JTSnx',
        AppPage: 'MainMenu',
        Module: 'JTSnxCore',
        PageFunction: 'VictimInfo',
      };
      this.jtsSidebarMenuService
        .insertUserTractingForMainMemu(userTractingModel)
        .subscribe(() => {
          window.open(
            this.serverUrl +
              'JTSnxVictimInfo/#/?tabid=' +
              this.tabId +
              '&djjuseracid=' +
              this.userAcID,
            '_self'
          );
        });
    }
  }

  isShowVideoConfButton() {
    const sitLocationCode = this.sitLocationCode;
    const allowSitLocationCodeList = [
      0,
      8,
      12,
      18,
      24,
      1002,
      1004,
      1006,
      1007,
      1020,
      1025,
      3024,
      3025,
      3026,
      5016,
      5061,
      5094,
    ];
    for (const item of allowSitLocationCodeList) {
      if (sitLocationCode === item) {
        return true;
      }
    }
    return false;
  }

  terminationClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxTermination') {
      this.currentModuleClicked.emit('JTSnxTermination');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Termination',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxTermination/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  fqasClicked() {
    this.userAcID = sessionStorage.getItem('DJJUserAcId');

    const userTractingModel = {
      UserId: this.userAcID,
      AppId: 'JTSnx',
      AppPage: 'MainMenu',
      Module: 'JTSnxCore',
      PageFunction: 'FAQs',
    };
    this.jtsSidebarMenuService
      .insertUserTractingForMainMemu(userTractingModel)
      .subscribe(() => {
        window.open(
          this.serverUrl + 'JTSnxFAQS/?userid=' + this.userID,
          '_blank',
          'width=800,height=600'
        );
      });
  }

  reportIssueClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
  }

  djjWebsiteClicked() {
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    const userTractingModel = {
      UserId: this.userAcID,
      AppId: 'JTSnx',
      AppPage: 'MainMenu',
      Module: 'JTSnxCore',
      PageFunction: 'DJJWebsite',
    };
    this.jtsSidebarMenuService
      .insertUserTractingForMainMemu(userTractingModel)
      .subscribe(() => {
        window.open('https://djj.georgia.gov/', '_self');
      });
  }

  reentryClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxReentry') {
      this.currentModuleClicked.emit('JTSnxReentry');
    } else {
      const item: any = this.jtsSidebarMenuService.propertyCofig.find(
        (a) => a.property === 'Reentry'
      );
      if (item.currentPlatform === 'Angular') {
        window.open(
          this.serverUrl +
            'JTSnxReentry/#/?tabid=' +
            this.tabId +
            '&djjuseracid=' +
            this.userAcID,
          '_self'
        );
      } else {
        this.jtsSidebarMenuService
          .setAuth(this.tabId, this.userAcID)
          .subscribe(() => {
            const userTractingModel = {
              UserId: this.userAcID,
              AppId: 'JTSnx',
              AppPage: 'MainMenu',
              Module: 'JTSnxCore',
              PageFunction: 'Reentry',
            };
            this.jtsSidebarMenuService
              .insertUserTractingForMainMemu(userTractingModel)
              .subscribe(() => {
                window.open(
                  this.serverUrl +
                    'JTSnxCore/#/?tabid=' +
                    this.tabId +
                    '&djjuseracid=' +
                    this.userAcID +
                    '&isToReentry=true',
                  '_self'
                );
              });
          });
      }
    }
  }

  maintenanceClicked() {
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    this.tabId = sessionStorage.getItem('TabId');
    const userTractingModel = {
      UserId: this.userAcID,
      AppId: 'JTSnx',
      AppPage: 'MainMenu',
      Module: 'JTSnxCore',
      PageFunction: 'Maintenance',
    };
    this.jtsSidebarMenuService
      .insertUserTractingForMainMemu(userTractingModel)
      .subscribe(() => {
        window.open(
          this.serverUrl +
            'JTSnxCore/#/?tabid=' +
            this.tabId +
            '&djjuseracid=' +
            this.userAcID +
            '&isToMaintenance=true',
          '_self'
        );
      });
  }

  searchClicked() {
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    const userTractingModel = {
      UserId: this.userAcID,
      AppId: 'JTSnx',
      AppPage: 'MainMenu',
      Module: 'JTSnxCore',
      PageFunction: 'Search',
    };
    this.jtsSidebarMenuService
      .insertUserTractingForMainMemu(userTractingModel)
      .subscribe(() => {
        this.toSearch();
      });
  }

  listAcitive(index) {
    // tslint:disable-next-line:forin
    for (const i in this.buttonActive) {
      this.buttonActive[i] = false;
    }
    this.buttonActive[index] = true;
  }

  aboutUrlTransform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      this.serverUrl + 'cdn/about.html'
    );
  }

  archiveClicked() {
    this.tabId = sessionStorage.getItem('TabId');
    this.userAcID = sessionStorage.getItem('DJJUserAcId');
    if (this.moduleName === 'JTSnxArchive') {
      this.currentModuleClicked.emit('JTSnxArchive');
    } else {
      if (
        this.juvenileID === -1 ||
        this.juvenileID === null ||
        this.juvenileID === undefined
      ) {
        this.searchClicked();
      } else {
        const userTractingModel = {
          UserId: this.userAcID,
          AppId: 'JTSnx',
          AppPage: 'MainMenu',
          Module: 'JTSnxCore',
          PageFunction: 'Archive',
        };
        this.jtsSidebarMenuService
          .insertUserTractingForMainMemu(userTractingModel)
          .subscribe(() => {
            window.open(
              this.serverUrl +
                'JTSnxArchive/#/?tabid=' +
                this.tabId +
                '&djjuseracid=' +
                this.userAcID,
              '_self'
            );
          });
      }
    }
  }

  isPrintable() {
    return window.location.href.toString().includes('offensesummary');
  }

  isShowButton(buttonName) {
    const item: any = this.jtsSidebarMenuService.propertyCofig.find(
      (a) => a.property === buttonName
    );
    if (item !== undefined) {
      return item.propertyOn;
    } else {
      return false;
    }
  }
}
